import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import NewsletterForm from "../NewsletterForm";

export default function Footer() {
  return (
    <footer className="bg-[var(--eai-ink)] text-white" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-7">
            <p className="overline text-[var(--eai-accent)]">Stay informed</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight mt-4">
              The weekly briefing on responsible AI — written for people who decide.
            </h2>
            <p className="mt-6 text-white/70 max-w-xl text-base sm:text-lg leading-relaxed">
              Curated intelligence on AI ethics research, policy, and industry deployment. Concise. Evidence-informed. No noise.
            </p>
            <div className="mt-8 max-w-lg">
              <NewsletterForm variant="dark" />
            </div>
          </div>

          <div className="lg:col-span-5 grid grid-cols-2 gap-10">
            <div>
              <p className="overline text-white/40">Explore</p>
              <ul className="mt-4 space-y-3 text-sm">
                <li><Link to="/intelligence" className="hover:text-[var(--eai-accent)]" data-testid="footer-intelligence-link">Intelligence</Link></li>
                <li><Link to="/resources" className="hover:text-[var(--eai-accent)]" data-testid="footer-resources-link">Resources</Link></li>
                <li><Link to="/industries" className="hover:text-[var(--eai-accent)]" data-testid="footer-industries-link">Industries</Link></li>
                <li><Link to="/community" className="hover:text-[var(--eai-accent)]" data-testid="footer-community-link">Community</Link></li>
                <li>
                  <a href="https://ethicalainow.org" target="_blank" rel="noopener noreferrer" className="hover:text-[var(--eai-accent)] inline-flex items-center gap-1.5" data-testid="footer-shop-link">
                    Shop <span aria-hidden className="text-white/40">↗</span>
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <p className="overline text-white/40">Organisation</p>
              <ul className="mt-4 space-y-3 text-sm">
                <li><Link to="/manifesto" className="hover:text-[var(--eai-accent)]" data-testid="footer-manifesto-link">Manifesto</Link></li>
                <li><Link to="/about" className="hover:text-[var(--eai-accent)]" data-testid="footer-about-link">About</Link></li>
                <li><Link to="/contact" className="hover:text-[var(--eai-accent)]" data-testid="footer-contact-link">Contact</Link></li>
                <li>
                  <a href="https://www.linkedin.com/in/ethical-ai-now/" target="_blank" rel="noopener noreferrer" className="hover:text-[var(--eai-accent)] inline-flex items-center gap-1.5" data-testid="footer-linkedin-link">
                    LinkedIn <span aria-hidden className="text-white/40">↗</span>
                  </a>
                </li>
                <li><span className="text-white/60">Editorial standards</span></li>
                <li><span className="text-white/60">Disclosures</span></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/15 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-xs font-mono-eai uppercase tracking-[0.18em] text-white/50">
          <div className="flex items-center gap-4">
            <p>© {new Date().getFullYear()} Ethical AI Now — Independent. Global.</p>
          </div>
          <div className="flex items-center gap-5">
            <a
              href="https://www.linkedin.com/in/ethical-ai-now/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Matthew Kilkenny on LinkedIn"
              data-testid="footer-linkedin-icon"
              className="w-9 h-9 inline-flex items-center justify-center border border-white/20 text-white/70 hover:text-[var(--eai-ink)] hover:bg-white hover:border-white transition-colors duration-200"
            >
              <Linkedin size={14} strokeWidth={1.8} />
            </a>
            <p className="hidden sm:block">Rigorous · Accessible · Evidence-informed</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
